// extracted by mini-css-extract-plugin
export default {"surcontainer":"menuIcon_surcontainer__w3hEo","container":"menuIcon_container__-j-Ac","flyin":"menuIcon_flyin__XVE86","hold":"menuIcon_hold__BgWO0","flyout":"menuIcon_flyout__1kNy9"};